export enum MUTATION_KEYS {
  SAVE_ANNOTATION = 'SAVE_ANNOTATION',
  DELETE_ANNOTATION = 'DELETE_ANNOTATION',
}

export default MUTATION_KEYS
